module["exports"] = [
  "Schweiz"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_CH/address/default_country.js
// module id = 307
// module chunks = 0